import { useRef } from "react";
import { useState } from "react";
import UserManagementActions from "../../Actions/UserManagementActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const BlockOrganisation = (props) => {
  const { orgid } = props;
  const [reason, setReason] = useState("");
  const blockModal = useRef();
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const blockOrganisation = (e) => {
    e.preventDefault();
    var blockData = {
      organisationId: orgid,
      reason: reason,
    };
    setGlobalSpinner(true);
    UserManagementActions.blockOrganisation(blockData);
  };

  return (
    <div
      className="modal fade"
      id="blockModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="blockModalLabel"
      aria-hidden="true"
      ref={blockModal}
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="blockModalLabel">
              {localization.blockOrg}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="blockModalClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="blockOrgForm" onSubmit={blockOrganisation}>
            <div className="modal-body">
              <div className="form-group">
                <textarea
                  className="form-control"
                  placeholder={localization.blockingReason}
                  required
                  id="blockReason"
                  name="blockReason"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                ></textarea>
              </div>
            </div>
            <div className="modal-footer py-2">
              <div className="form-group">
                <button type="submit" className="btn btn-primary">
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BlockOrganisation;
